import type { QuizPage } from './types'

export const quizPagesZhTw: QuizPage[] = [
  {
    id: 'intro',
    type: 'showcase',
    image: 'https://cdn-site.clarymind.com/clarymind-tools-cover.jpg',
    title: '五分鐘快速檢測你的「手機成癮指數」',
    description: '',
    ctaText: '開始測驗',
  },
  {
    id: 'phone-usage-context',
    type: 'multi-select',
    question: '你最常在哪些情況下滑手機？',
    options: [
      { value: 'work', label: '工作或讀書時' },
      { value: 'sleep', label: '睡前' },
      { value: 'commute', label: '通勤或排隊等待' },
      { value: 'toilet', label: '廁所' },
      { value: 'always', label: '其實隨時都在滑' },
    ],
    minSelect: 1,
  },
  {
    id: 'phone-usage-aftermath',
    type: 'multi-select',
    question: '當你開始滑手機時，通常會發生什麼？',
    options: [
      { value: 'time-flies', label: '本來只想看一下，結果一滑就是一小時' },
      { value: 'unconscious', label: '無意識，或忘記為什麼打開手機' },
      { value: 'app-hopping', label: '一直在不同 app 間來回跳' },
      { value: 'emptiness', label: '滑到一半忽然感到空虛，發現不知道自己到底想看什麼' },
    ],
    minSelect: 1,
  },
  {
    id: 'impact',
    type: 'showcase',
    image: 'https://cdn-site.clarymind.com/clarymind-tools-cover.jpg',
    title: '手機如何影響我們的專注、情緒與健康',
    description: '持續的注意力中斷，會讓大腦更難進入深度專注。Clarymind 的設計理念很簡單：幫助你在「打開 app 的那一刻」，重新意識到自己正在做什麼。',
  },
  {
    id: 'phone-usage-pain-point',
    type: 'single-select',
    question: '以下哪種情況最困擾你？',
    options: [
      { value: 'work', label: '工作或讀書容易分心' },
      { value: 'sleep', label: '睡眠品質不好，或難以入睡' },
      { value: 'boredom', label: '總是覺得很無聊，一直想尋求新鮮刺激' },
      { value: 'anxiety', label: '滑社群後感到焦慮或空虛' },
    ],
  },
  {
    id: 'daily-usage-hours',
    type: 'single-select',
    question: '你每天大約花多少時間在手機上？',
    options: [
      { value: '2-4', label: '2 - 4 小時' },
      { value: '4-6', label: '4 - 6 小時' },
      { value: '6-8', label: '6 - 8 小時' },
      { value: '10+', label: '10 小時以上' },
    ],
  },
  {
    id: 'age-group',
    type: 'single-select',
    question: '你現在幾歲？',
    options: [
      { value: '13-18', label: '13 - 18' },
      { value: '18-24', label: '18 - 24' },
      { value: '25-34', label: '25 - 34' },
      { value: '35-44', label: '35 - 44' },
      { value: '45-54', label: '45 - 54' },
      { value: '55+', label: '55 +' },
    ],
  },
  {
    id: 'reduce-usage-showcase',
    type: 'showcase',
    image: 'https://cdn-site.clarymind.com/clarymind-tools-cover.jpg',
    title: '好消息是，有一個簡單的方法，可以幫助你每天少滑 2 小時',
    description: '即便只有短暫的覺察，也能幫助你打破自動導航。Clarymind 專為此設計，幫助你重新建立與手機的關係。',
  },
  {
    id: 'free-time-usage',
    type: 'multi-select',
    question: '如果每天少滑 2 小時手機，你最希望多出來的時間用來做什麼？',
    options: [
      { value: 'productivity', label: '提升工作效率' },
      { value: 'learning', label: '學習新技能，轉職、升職或加薪' },
      { value: 'sports', label: '運動' },
      { value: 'rest', label: '好好休息' },
      { value: 'family', label: '陪伴家人或朋友' },
    ],
    minSelect: 1,
  },
  {
    id: 'potential-showcase',
    type: 'showcase',
    image: 'https://cdn-site.clarymind.com/clarymind-tools-cover.jpg',
    title: '想像一下，如果你的每一天都能發揮潛力，三年後，你會成為怎麼樣的人？',
    description: '很多人下載 Clarymind 的原因都很簡單：想重新掌控自己的時間。一位使用者分享：「我原本每天滑手機 5 小時以上。使用 Clarymind 兩週後，下降到 2.5 小時。最驚訝的是，我其實沒有感到被限制，只是更常意識到自己在做什麼。」',
    ctaText: '繼續',
  },
  {
    id: 'morning-phone',
    type: 'yes-no',
    question: '你起床第一件事是拿手機嗎？',
    options: [
      { value: 'yes', label: '是' },
      { value: 'no', label: '不是' },
    ],
  },
  {
    id: 'before-bed-phone',
    type: 'yes-no',
    question: '你睡前會躺在床上滑手機嗎？',
    options: [
      { value: 'yes', label: '會' },
      { value: 'no', label: '不會' },
    ],
  },
  {
    id: 'toilet-phone',
    type: 'yes-no',
    question: '你會把手機帶進廁所、邊上邊滑嗎？',
    options: [
      { value: 'yes', label: '會' },
      { value: 'no', label: '不會' },
    ],
  },
  {
    id: 'taiwan-stats-showcase',
    type: 'showcase',
    image: 'https://cdn-site.clarymind.com/clarymind-tools-cover.jpg',
    title: '你知道嗎？台灣人平均每 10 分鐘就會看一次手機，每天會拿起來 96 次',
    description: '我們正在集體面臨注意力被掠奪的現況。但你可以主動選擇。',
  },
  {
    id: 'anxiety-without-phone',
    type: 'yes-no',
    question: '如果出門發現忘記帶手機，你會焦慮嗎？',
    options: [
      { value: 'yes', label: '會' },
      { value: 'no', label: '不會' },
    ],
  },
  {
    id: 'social-media-for-anxiety',
    type: 'yes-no',
    question: '焦慮時，你會用滑社群來轉移注意力嗎？（可能是下意識地打開）',
    options: [
      { value: 'yes', label: '會' },
      { value: 'no', label: '不會' },
    ],
  },
  {
    id: 'thirty-mins-focus',
    type: 'yes-no',
    question: '看書或追劇時，你可以半小時以上不碰手機嗎？',
    options: [
      { value: 'yes', label: '可以' },
      { value: 'no', label: '不行' },
    ],
  },
  {
    id: 'success-case-showcase',
    type: 'showcase',
    image: 'https://cdn-site.clarymind.com/clarymind-tools-cover.jpg',
    title: '真實案例分享',
    description: '從整天無意識滑手機，到每天多出兩小時閱讀與陪伴家人。Clarymind 幫助使用者重拾生活的重心。',
    ctaText: '繼續',
  },
  {
    id: 'tried-reduction',
    type: 'single-select',
    question: '你是否曾經嘗試減少手機使用？',
    options: [
      { value: 'tried-hard', label: '有，但很難維持' },
      { value: 'want-to-start', label: '一直想改變，但還沒開始 / 還沒找到方法' },
      { value: 'never-thought', label: '沒有想過' },
    ],
  },
  {
    id: 'methods-tried',
    type: 'multi-select',
    question: '你試過哪些方法？',
    options: [
      { value: 'delete-apps', label: '把社群 app 刪掉' },
      { value: 'screen-time', label: 'iPhone 內建的螢幕使用時間功能' },
      { value: 'focus-apps', label: '專注 app（如：種樹）' },
      { value: 'dumb-phone', label: '改用傳統非智慧型手機' },
    ],
    minSelect: 0,
  },
  {
    id: 'clarymind-design-space',
    type: 'showcase',
    image: 'https://cdn-site.clarymind.com/clarymind-tools-cover.jpg',
    title: 'Clarymind 的設計不是「限制」，而是「給自己重新選擇的空間」',
    description: '當你打開容易分心的 app 時，Clarymind 會先請你停下來想一下：「你現在為什麼要打開這個 app？」這個簡單的停頓，往往就足以打破無意識滑手機的循環。',
    ctaText: '繼續',
  },
  {
    id: 'user-identity',
    type: 'single-select',
    question: '你的主要身份',
    options: [
      { value: 'student', label: '學生' },
      { value: 'employee', label: '上班族' },
      { value: 'executive', label: '中高階主管' },
      { value: 'freelancer', label: '自由工作者' },
      { value: 'entrepreneur', label: '創業者' },
    ],
  },
  {
    id: 'user-gender',
    type: 'single-select',
    question: '你的性別',
    options: [
      { value: 'male', label: '男' },
      { value: 'female', label: '女' },
      { value: 'non-binary', label: '非二元' },
      { value: 'prefer-not-to-say', label: '不想透露' },
    ],
  },
  {
    id: 'transition',
    type: 'transition',
    message: '正在分析你的結果...',
    durationMs: 1500,
  },
  {
    id: 'results',
    type: 'showcase',
    image: 'https://cdn-site.clarymind.com/product-page-app/benefits/benefit-01.jpg',
    title: 'Clarymind 為你量身打造',
    description: '根據你的回答，Clarymind 能幫助你打破滑手機的循環，建立持久的專注習慣。',
    socialProof: { testimonials: true, ratings: true },
  },
]
